import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { isLoadingCommonFilters } from "@signals"
import { areCommonFiltersValid } from "@signals/commonFilters/filters"
import { Box } from "@mui/material"


export default function LeadingAnalyzerFiltersFooterActions() {

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-around", gap: 1, my: 1 }}>
		<ButtonLoadingSeeker
			loading={isLoadingCommonFilters.value}
			sx={{ px: 4 }}
			onClick={() => isLoadingCommonFilters.value = true}
			disabled={!areCommonFiltersValid.value}
		>
			Search
		</ButtonLoadingSeeker>
	</Box>
}